import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { useEditBooksMutation, useGetBookQuery } from '../../features/apiSlice/apiSlice';

const EditBook = () => {
    const { register, handleSubmit, reset, watch, setValue, formState: { errors } } = useForm();
    const { id } = useParams()
    const { data, isLoading, isError } = useGetBookQuery(id);
    const navigate = useNavigate()
    const [editBook, { isLoading: isUpdateLoading, isError: isUpdateError, isSuccess: isUpdateSuccess }] = useEditBooksMutation()
    // handle getting data
    useEffect(() => {
        if (!isLoading && data?.id) {
            Object.keys(data).forEach(key => {
                if (key !== 'id')
                    setValue(key, data[key])
            })
        }
    }, [data, isLoading, setValue])

    // handle update
    const onSubmit = (data) => {
        editBook({ data, id })
    }

    useEffect(() => {
        if (isUpdateError) {
            alert('sorry try again')
        }
        if (isUpdateSuccess) {
            navigate('/')
        }
    }, [isUpdateError, isUpdateSuccess])
    let content = null
    if (!isLoading && isError) {
        content = <div className='text-center'>Something is wrong Data not found</div>
    }

    if (!isLoading && !isError && !data?.id) {
        content = <div className='text-center'>Books not found</div>
    }

    if (!isLoading && !isError && data?.id) {
        content = <div className="container">
            <div className="p-8 overflow-hidden bg-white shadow-cardShadow rounded-md max-w-xl mx-auto">
                <h4 className="mb-8 text-xl font-bold text-center">Edit Book</h4>
                <form onSubmit={handleSubmit(onSubmit)} className="book-form">
                    <div className="space-y-2">
                        <label for="lws-bookName">Book Name</label>
                        <input required className="text-input" type="text" id="lws-bookName" name="name" {...register("name", { required: true })} />
                    </div>

                    <div className="space-y-2">
                        <label for="lws-author">Author</label>
                        <input required className="text-input" type="text" id="lws-author" name="author" {...register("author", { required: true })} />
                    </div>

                    <div className="space-y-2">
                        <label for="lws-thumbnail">Image Url</label>
                        <input required className="text-input" type="text" id="lws-thumbnail" name="thumbnail"  {...register("thumbnail", { required: true })} />
                    </div>

                    <div className="grid grid-cols-2 gap-8 pb-4">
                        <div className="space-y-2">
                            <label for="lws-price">Price</label>
                            <input required className="text-input" type="number" step='any' id="lws-price" name="price" {...register("price", { required: true })} />
                        </div>

                        <div className="space-y-2">
                            <label for="lws-rating">Rating</label>
                            <input required className="text-input" type="number" id="lws-rating" name="rating" min="1"
                                max="5"  {...register("rating", { required: true })} />
                        </div>
                    </div>

                    <div className="flex items-center">
                        <input id="lws-featured" type="checkbox" name="featured" className="w-4 h-4"  {...register("featured")} />
                        <label for="lws-featured" className="ml-2 text-sm"> This is a featured book </label>
                    </div>

                    <button disabled={isUpdateLoading} type="submit" className="submit" id="lws-submit">{isUpdateLoading ? "Loading..." : "Edit Book"}</button>
                </form>
            </div>
        </div>
    }
    return (
        <main className="py-6 2xl:px-6">
            {content}
        </main>
    );
};

export default EditBook;